export default "__VITE_ASSET__76a3d5c3__"